import React, { useEffect, Fragment, useContext, useState } from 'react';
import Layout from './layouts/Layout';
import AppContext from './context/Context';
import { fetchCurrentUser } from './helpers/account';
import SparqlHook from './SparqlHook.js';

const App = () => {
  const { setIsAuthenticated, currentUser, setCurrentUser, setCurrentUserPic, organizationList, setOrganizationList, setOrganizationLookupList, originalUrl, setOriginalUrl } = useContext(AppContext);
  const [ isValidated, setIsValidated ] = useState(false);
  const { runQuery } = SparqlHook();  
  
  // if (process.env.NODE_ENV === 'production') clarity.init('m4sj36j33n');

  const checkLogin = async () => {    
    let user = await fetchCurrentUser();
    let checkedUser = user ? [user] : null;
    if(checkedUser) {
      setIsAuthenticated(true);
      if(checkedUser[0].name !== currentUser.name || checkedUser[0].user !== currentUser.user || checkedUser[0].roles !== currentUser.roles || checkedUser[0].organization !== currentUser.organization || checkedUser[0].email !== currentUser.email || checkedUser[0].profile_picture !== currentUser.profile_picture || checkedUser[0].defaultIndustry !== currentUser.defaultIndustry) {
        setCurrentUserPic(checkedUser[0].profile_picture);
        setCurrentUser(checkedUser[0]);
      }
      if(!organizationList || organizationList.length === 0) {
        let contractorList = [];
        let queryString = `
        PREFIX kg: <https://deepick.eu/schema/kg/v1/pred#>
          PREFIX at-kdvo-raw: <https://deepick.eu/schema/at-kdvo-raw/v1/pred#>
          PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
          PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
          PREFIX core: <https://deepick.eu/schema/sql-import/v1/pred#>
          PREFIX core-type: <https://deepick.eu/schema/sql-import/v1/type#>

          SELECT ?org ?name ?mainType
          WHERE {
            ?org rdf:type core-type:organization.
            ?org core:name ?name.
            ?org core:mainType ?mainType.
          }

          GROUP BY ?org
          ORDER BY ?name
        `
        runQuery({ query: queryString})
        .then(result => {
          setOrganizationList(result);            
          setOrganizationLookupList(result);


          
        });

      }
      setIsValidated(true);
    }
    else
    {
      // console.log(new Date(), 'No valid redenticals');
      setIsAuthenticated(false);
      setCurrentUser({});
      setCurrentUserPic('');
      setIsValidated(true);
    }
  }

  useEffect( () => {
    checkLogin();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(() => {
    if (!originalUrl) {
      setOriginalUrl(window.location.href);
    }
  }, [originalUrl, setOriginalUrl]);

  useEffect(() => {
    const handleSessionExpired = () => {
      setIsAuthenticated(false);
      setCurrentUser({});
      setCurrentUserPic('');
    };
    window.addEventListener('auth:session-expired', handleSessionExpired);
    return () => window.removeEventListener('auth:session-expired', handleSessionExpired);
  }, [setIsAuthenticated, setCurrentUser, setCurrentUserPic]);

  if(isValidated) {
    return <Layout />;
  }
  else {
    return(
      <Fragment></Fragment>
    )
  }
}

export default App;